<template>
  <div class="input-transition-videos">
    <label>Page Transition Videos</label>

    <InputMultiSelect
      v-model="entityIdsToTransition"
      :options="entityOptions"
    />

    <div>
      <div v-for="entity in entitiesToTransition" :key="entity._id">
        <div v-if="entity">
          <div>{{ `${entity.type} - ${entity.name || entity.label}` }}</div>

          <!-- Control setting so we can $set for new keys -->
          <InputAsset
            :value="pageTransitionVideos[entity._id] || ''"
            @input="val => setTransitionVideo(entity._id, val)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputAsset from "@/components/InputAsset";
import InputMultiSelect from "@/components/InputMultiSelect";

export default {
  // v-model expects a `value` prop and `input` event on the component
  props: ['value'],

  components: {
    InputAsset,
    InputMultiSelect
  },

  data() {
    return {
      entityIdsToTransition: [],
      // keep a local, mutable copy
      pageTransitionVideos: { ...this.value }
    };
  },

  computed: {
    // create shallow copies to avoid mutating Vuex state
    entities() {
      const pages = (this.$store.state.page.pages || []).map(p => ({
        ...p,
        type: "Page"
      }));
      const subs = (this.$store.state.living.subsections || []).map(s => ({
        ...s,
        type: "Subsection"
      }));
      const living = (this.$store.state.living.livingOptions || []).map(l => ({
        ...l,
        type: "Living Option"
      }));
      return [...pages, ...subs, ...living];
    },

    entitiesToTransition() {
      const ids = this.entityIdsToTransition || [];
      return this.entities.filter(e => ids.includes(e._id));
    },

    entityOptions() {
      return this.entities
        .map(entity => ({
          label: entity.name || entity.label,
          value: entity._id
        }));
    }
  },

  watch: {
    // if parent changes v-model from outside, sync local copy
    value: {
      handler(newVal) {
        this.pageTransitionVideos = { ...newVal };
        delete this.pageTransitionVideos.default // remove default key, left-over from legacy API model
        // also refresh selected IDs derived from keys
        this.entityIdsToTransition = Object.keys(this.pageTransitionVideos);
      },
      deep: true
    },

    // when the selection changes, ensure missing keys exist (reactively)
    entityIdsToTransition(newIds) {
      newIds.forEach(id => {
        if (!(id in this.pageTransitionVideos)) {
          this.$set(this.pageTransitionVideos, id, "");
        }
      });
      // also remove keys no longer selected
      Object.keys(this.pageTransitionVideos).forEach(id => {
        if (!newIds.includes(id)) {
          this.$delete(this.pageTransitionVideos, id);
        }
      });
    }
  },

  methods: {
    setTransitionVideo(id, val) {
      // ensure reactivity when adding new keys
      this.$set(this.pageTransitionVideos, id, val);
      this.$emit("input", this.pageTransitionVideos);
    }
  },

  async mounted() {
    await Promise.all([
      this.$store.dispatch('FETCH_LIVING_OPTIONS'),
      this.$store.dispatch('FETCH_SUBSECTIONS'),
      this.$store.dispatch('fetchPages')
    ])
    // derive the initial selected IDs from incoming value
    const keys = Object.keys(this.pageTransitionVideos);
    if (keys.length) {
      this.entityIdsToTransition = keys;
    }
  }
};
</script>

<style lang="scss">
.input-transition-videos {
}
</style>
